<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <h1>{{ constants['MANAGE_PROFILE_TEXT'] }}</h1>
              </div>
            </div>
            <div class="white-bg-border">
              <div class="manage-profile-section">
                <h2>{{ constants['PROFILE_TEXT'] }}</h2>
                <div class="manage-profile-box">
                  <div class="profile-edit-btn">
                    <router-link to="/authority/edit-profile" id="editProfileLink" class="admin-btn-outline-primary">
                      <i>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M15.7594 4.73184L12.268 1.24122C12.1519 1.12511 12.0141 1.03301 11.8624 0.970178C11.7107 0.907342 11.5482 0.875 11.384 0.875C11.2198 0.875 11.0572 0.907342 10.9056 0.970178C10.7539 1.03301 10.6161 1.12511 10.5 1.24122L0.866413 10.8748C0.749834 10.9905 0.657407 11.1281 0.594506 11.2798C0.531604 11.4315 0.499482 11.5942 0.500006 11.7584V15.2498C0.500006 15.5813 0.631702 15.8993 0.866123 16.1337C1.10054 16.3681 1.41849 16.4998 1.75001 16.4998H14.875C15.0408 16.4998 15.1997 16.434 15.3169 16.3168C15.4342 16.1995 15.5 16.0406 15.5 15.8748C15.5 15.7091 15.4342 15.5501 15.3169 15.4329C15.1997 15.3157 15.0408 15.2498 14.875 15.2498H7.00938L15.7594 6.49981C15.8755 6.38373 15.9676 6.24592 16.0304 6.09425C16.0933 5.94257 16.1256 5.78 16.1256 5.61583C16.1256 5.45165 16.0933 5.28908 16.0304 5.13741C15.9676 4.98573 15.8755 4.84792 15.7594 4.73184ZM8.62501 4.8834L9.92891 6.18731L3.31251 12.8037L2.0086 11.4998L8.62501 4.8834ZM1.75001 15.2498V13.0084L3.99141 15.2498H1.75001ZM5.50001 14.9912L4.19688 13.6873L7.50469 10.3791L10.8125 7.0709L12.1164 8.37481L5.50001 14.9912ZM13 7.49122L9.50938 3.99981L11.3844 2.12481L14.875 5.61622L13 7.49122Z"
                            fill="#0095FF" />
                        </svg>
                      </i>
                      {{ constants['EDIT_PROFILE_MENU'] }}
                    </router-link>
                  </div>
                  <div class="edit-profile-form">
                    <div class="admin-custom-row box-row-2">
                      <div class="admin-input-field">
                        <label>{{ constants.FIRST_NAME_LABEL }}</label>
                        <strong class="strong-block">{{ firstname }}</strong>
                      </div>
                      <div class="admin-input-field">
                        <label>{{ constants['LAST_NAME_LABEL'] }}</label>
                        <strong class="strong-block">{{ lastname }}</strong>
                      </div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants['EMAIL_LABEL'] }}</label>
                      <strong class="strong-block">{{ email }}</strong>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants['PROFILE_PICTURE_LABEL'] }}</label>
                      <div class="admin-upload-profile">
                        <img :src="imageUrl" alt="Avatar" />
                      </div>
                    </div>
                    <!-- <div class="admin-input-field-submit">
                      <button class="admin-btn-outline-primary">{{ constants['SUBMIT_BUTTON'] }}</button>
                      <button class="admin-btn-outline-secondary">{{ constants['CANCEL_BUTTON'] }}</button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">{{ constants['COPYRIGHT_TEXT'] }}</div>
    </footer>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import constants from '@/utils/en-US-Admin.json';
import axios from 'axios';
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { API_BASE_URL } from '@/config/api.config';


export default defineComponent({
  name: "Profile",
  data() {
    const profileImage = localStorage.getItem('profile_image');
    const baseUrl = `${API_BASE_URL}`;

    return {
      constants,
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      email: localStorage.getItem('email'),
      profile_image: profileImage ? `${baseUrl}${profileImage}` : '',
    };
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  computed: {
    imageUrl(): string {
      return (this as any).profile_image || require('@/assets/images/img_avatar.png');
    },
  },
  components: {
    adminHeader,
    adminNavigation,
  },
});
</script>